import { parseFeatureFlag } from "@balabalabom/ui";

/**
 * Feature flags for client-public app.
 * Control via REACT_APP_FEATURE_* environment variables.
 */

/** Mini-Book Builder (templates, create project, page editor, export) */
export const isMiniBookEnabled = parseFeatureFlag(
  process.env.REACT_APP_FEATURE_MINIBOOK
);
